module.exports = __webpack_public_path__ + "static/media/8_C2.25ffaf74.png";